module.exports = __webpack_public_path__ + "static/media/icon-supplies-scissors.2382ab84.svg";